// This creates convenience store-based functions
var store;

// NOTE Also see: ./storeInfo

// PLEASE ALSO NOTE: This component can also be used from components that have no store,
// yet. This functionality will be removed when all components have access to the store.
// It requires a `window.fakeStore` variable

// EXAMPLE USAGE
//   import { hasFeature } from "shared/features"
//
// In JSX:
//   { hasFeature("directOrders") && <RenderThisComponent/> }

export function syncFeaturesWithStore(newStore) {
  store = newStore;
  return true;
}

export function hasFeature(featureMapping) {
  return store
    ? store.getState().app.features[featureMapping]
    : window.fakeStore.app.features[featureMapping];
}
